import { Routes } from '@angular/router';

export const clientRoutes: Routes = [
    { path: '', loadComponent: () => import('./client-page/client-page.component').then(m => m.ClientPageComponent) },
    { path: 'service/:serviceId', loadComponent: () => import('./client-page/client-page.component').then(m => m.ClientPageComponent) },
    { path: ':providerOrStoreSlug', loadComponent: () => import('./client-page/client-page.component').then(m => m.ClientPageComponent) },
    { path: 'cancellation/:bookingId/:bookingCode', loadComponent: () => import('./client-page/client-page.component').then(m => m.ClientPageComponent), data: { type: 'cancelBooking' } },
    { path: 'pay/sale/:saleId/:payCode', loadComponent: () => import('./client-page/client-page.component').then(m => m.ClientPageComponent), data: { type: 'paySale' } },
    { path: 'pay/:bookingId/:bookingCode', loadComponent: () => import('./client-page/client-page.component').then(m => m.ClientPageComponent), data: { type: 'payBooking' } },
];

